import { useEffect, useState, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { IoClose } from "react-icons/io5";
import { toggleMobileAddressModal } from '../../../redux/addresslice';
import { IoSearch } from "react-icons/io5";
import { GoogleMap, LoadScript, MarkerF } from "@react-google-maps/api";
import { PiGps } from "react-icons/pi";
import { CiLocationOn } from "react-icons/ci";
import useCurrentLocation from '../../../hooks/useCurrentLocation';
import useFormValidation from '../../../hooks/useFormValidation';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import ClipLoader from "react-spinners/ClipLoader";

import Inputbox from '../Inputbox';
import NationalityDropdown from '../NationalityDropdown';
import { getLocations, getAreas } from '../../../redux/globalslice';
import { InputBox1 } from '../formInputs';
import { postUserAddress, getalladdressesapi } from "../../../redux/addresslice";
import { setAddressButtonLoading } from "../../../redux/addresslice";
function MobileAddressModal() {
    const dispatch = useDispatch()
    const inputs = ['name', 'emirate', 'number', 'address', 'area'];

    const mobile_address_modal = useSelector(state => state.addresslice.mobile_address_modal);
    const address_header = useSelector(state => state.addresslice.address_header);
    const addresslistdata = useSelector(state => state.addresslice.addresslistdata);
    const locationsdata = useSelector(state => state.globalslice.locationsdata);
    const areadata = useSelector(state => state.globalslice.areadata);
    const loading1 = useSelector(state => state.globalslice.loading1);
    const addressButtonLoader = useSelector(state => state.addresslice.loading1)
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);

    const { handleChange, formValues, setFormValues, errors, isClickable } = useFormValidation({ inputs })

    const [address, setAddres] = useState("");

    const [step, setstep] = useState(false);

    const { location, setLocation, handleDragEnd, addressData, handleLocateme, setAddress } = useCurrentLocation({ address_header })

    useEffect(() => {
        if (addressData != '') {
            setFormValues({
                ...formValues,
                'address': addressData,
                'address2': addressData
            })
        }
    }, [addressData])


    const handleDragMap = (e) => {
        setstep(true)
        handleDragEnd(e)
    }

    useEffect(() => {
        dispatch(getLocations())
    }, [])

    const handleSelect = async (selectedAddress) => {
        setstep(false)

        const results = await geocodeByAddress(selectedAddress);
        const latLng = await getLatLng(results[0]);
        setLocation(latLng)
        setFormValues({
            ...formValues,
            'address': selectedAddress,
            'address2': selectedAddress
        })
        setAddres(selectedAddress)
        setcurrent_Step(1);
        inputRef.current?.blur();
    };

    const [isFocused, setIsFocused] = useState(false);
    const [current_Step, setcurrent_Step] = useState(0);

    const handleFocus = () => {
        setcurrent_Step(0);
        setIsFocused(true);
    };


    const handleClose = () => {
        setIsFocused(false);
        setstep(false)
        setcurrent_Step(0)
        dispatch(toggleMobileAddressModal(false))
        setFormValues({})
    }



    useEffect(() => {
        if (address_header != 0) {
            var address_Details = addresslistdata.data.find(ele => ele.idaddress == address_header);
            setAddress(address_Details.address)
            setLocation({ lat: parseFloat(address_Details.latitude), lng: parseFloat(address_Details.longitude) });
            dispatch(getAreas(address_Details.emirate))
            setFormValues({
                idaddress: address_Details.idaddress,
                name: address_Details.first_name,
                emirate: address_Details.emirate,
                area: address_Details.area,
                ...currentcountry.isAreaCodeRequired && ({ number: address_Details.mobile.slice(2) }),
                ...!currentcountry.isAreaCodeRequired && ({ number: address_Details.mobile }),
                pre: address_Details.mobile.slice(0, -currentcountry.number_count)
            })
        }

    }, [address_header])


    const handleLocationChange = (e) => {
        if (e.target.value == null) {
            setFormValues(prev => {
                const updated = { ...prev };
                delete updated[e.target.name];
                return updated;
            });
        } else {
            if (e.target.name == 'pre') {
                setFormValues({
                    ...formValues,
                    'pre': e.target.value
                })
            } else {
                if (e.target.value != null) {
                    setFormValues({
                        ...formValues,
                        [e.target.name]: e.target.value
                    })
                    if (e.target.name == 'emirate') {
                        dispatch(getAreas(e.target.value))
                    }
                }
            }
        }

    }

    const handleSubmit = async () => {
        if (isClickable) {
            dispatch(setAddressButtonLoading(true))
            var input_data = {
                "idaddress": address_header,
                "first_name": formValues.name,
                "last_name": "",
                "address": formValues.address,
                "address2": formValues.address2,
                ...currentcountry.isAreaCodeRequired && ({ "pre": formValues.hasOwnProperty('pre') ? formValues.pre : 50 }),
                ...currentcountry.isAreaCodeRequired && ({  "mobile": formValues.hasOwnProperty('pre') ? formValues.pre + formValues.number : 50 + formValues.number }),
                ...!currentcountry.isAreaCodeRequired && ({ 'mobile' :formValues.number }),
                "emirate": formValues.emirate,
                "area": formValues.area,
                "building_name": "",
                "latitude": location.lat,
                "longitude": location.lng,
                "status": 0,
                "default_address": formValues.hasOwnProperty('default_address') ? formValues.default_address : true
            }
            await dispatch(postUserAddress(input_data))
            dispatch(getalladdressesapi(0));
            dispatch(setAddressButtonLoading(false))
            setcurrent_Step(0);
            setAddres('')
            handleClose()
            inputRef.current?.blur();
            setIsFocused(false);
        }



    }

    const inputRef = useRef(null);
    

    return (
        <>
            <Modal
                show={mobile_address_modal}
                backdrop="static"
                keyboard={false}
                centered
                fullscreen
                className='address_dropdown'
            >
                <LoadScript
                    googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                    libraries={["drawing", "places"]}
                >
                    <div className='mobile_address_modal'>





                        <PlacesAutocomplete value={address} onChange={setAddres} onSelect={handleSelect}>
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (


                                <div className="position-relative">

                                    <div className='mobile_address_modal_header'>
                                        <div onClick={() => {
                                            if (!isFocused) {
                                                handleClose()
                                                setAddres('')
                                                handleLocateme()
                                                // setFormValues({
                                                //     'address': '',
                                                // })
                                            }
                                            setcurrent_Step(0);
                                            setAddres('')
                                            inputRef.current?.blur();
                                            setIsFocused(false);

                                        }}>
                                            <img src='/assets/vector_icons/arrow_left.png' />
                                        </div>

                                        <div className='d-flex w-100 align-items-center'>
                                            <div className="d-flex footercontactus mobile_address w-100 mx-3">

                                                <input
                                                    {...getInputProps({
                                                        placeholder: 'What are you looking for?',
                                                        className: 'header-inputbox',
                                                        onFocus: handleFocus,
                                                        ref: inputRef,
                                                    })}


                                                />
                                                <div className="header-search secondarybackground" onClick={() => {
                                                    setcurrent_Step(1);
                                                    setIsFocused(true)

                                                    inputRef.current?.blur();
                                                }}>
                                                    <IoSearch size={16} className="iconcolor" />
                                                </div>
                                            </div>
                                        </div>
                                        <IoClose size={30} onClick={handleClose} />


                                    </div>

                                    {
                                        suggestions.length > 0 &&
                                        <div className="mobile_search_location_dropdown">
                                            {loading && <div>Loading...</div>}
                                            {suggestions.map((suggestion) => {
                                                const className = suggestion.active ? 'suggestion-item--active suggestion-item' : 'suggestion-item';
                                                // Modify the styling as per your requirement

                                                return (
                                                    <div
                                                        {...getSuggestionItemProps(suggestion, {
                                                            className,
                                                        })}

                                                    >
                                                        <CiLocationOn size={20} className='me-4' />  <div className='two_lines'>{suggestion.description}</div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    }

                                    {
                                        current_Step == 1 &&
                                        <div className='mobile_address_form address_form'>
                                            <h5>{address_header == 0 ? 'Add Address' : 'Update Address'}</h5>
                                            <Row className='address_form_header mt-3'>
                                                <Col lg={12}>
                                                    <InputBox1 name='name' placeholder="Name" handleChange={handleChange} value={formValues.name} />
                                                </Col>
                                                <Col sm={3} xs={3}>
                                                    <InputBox1 name='country_code' readonly handleChange={handleChange} value={currentcountry.country_code} />
                                                </Col>

                                                {
                                                    currentcountry.isAreaCodeRequired &&
                                                    <Col sm={3} xs={3} className='pe-0'>
                                                        <select className="address_input_box" name='pre' onChange={handleLocationChange} value={formValues.pre}>
                                                            <option value={50}>{50}</option>
                                                            {
                                                                [52, 54, 55, 56, 58].map((number) => {
                                                                    return (
                                                                        <option value={number}>{number}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </Col>
                                                }


                                                <Col sm={currentcountry.isAreaCodeRequired ? 6 : 9} xs={currentcountry.isAreaCodeRequired ? 6 : 9}>
                                                    <InputBox1 type='number' name='number' handleChange={handleChange} placeholder="Enter Mobile Number" value={formValues.number} />
                                                </Col>
                                                <Col lg={12} sm={6} xs={6} className='pe-0'>
                                                    <select className="address_input_box" name='emirate' onChange={handleLocationChange} value={formValues.emirate}>
                                                        <option value={null}>Select location</option>
                                                        {
                                                            locationsdata.map((data) => {
                                                                return (
                                                                    <option value={data.id}>{data.name}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </Col>
                                                <Col lg={12} sm={6} xs={6}>
                                                    <select className="address_input_box" name='area' onChange={handleLocationChange} value={formValues.area}>
                                                        <option value={null}>Select Area</option>
                                                        {
                                                            areadata.map((data) => {
                                                                return (
                                                                    <option value={data.id}>{data.name}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </Col>
                                                <Col lg={12}>
                                                    <InputBox1 name='address' placeholder="Flat no., House no., Building, landmark" handleChange={handleChange} value={formValues.address} />
                                                </Col>
                                            </Row>



                                        </div>
                                    }

                                </div>








                            )}
                        </PlacesAutocomplete>












                    </div>



                    <div className='modal_address_body'>


                        <Row >
                            <Col lg={12}>
                                {
                                    (!isFocused && !loading1) && Object.keys(location).length > 0 &&

                                    <div className="position-relative">
                                        <GoogleMap
                                            center={location}
                                            zoom={15}
                                            mapContainerStyle={{ height: '80vh', width: '100%' }}
                                        // onClick={(event) => setMarkerPosition({ lat: event.latLng.lat(), lng: event.latLng.lng() })}
                                        >

                                            <>
                                                <MarkerF
                                                    position={location}
                                                    draggable={true}
                                                    icon={{
                                                        url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
                                                        scaledSize: { width: 48, height: 48 },
                                                        anchor: { x: 24, y: 48 },
                                                    }}
                                                    onDragEnd={handleDragMap}

                                                // onDragStart={handleDragStart}
                                                />
                                            </>


                                        </GoogleMap>

                                        <div className="position-absolute locate_me_btn" onClick={handleLocateme}>
                                            Locate me <span className="ps-2"><PiGps size={18} color='rgba(25, 27, 28, 1)' /></span>
                                        </div>

                                    </div>

                                }
                            </Col>

                        </Row>

                        {
                            !isFocused &&
                            <div className='modal_address_footer'>
                                <div className='comp_1'>
                                    <h6>Delivering your order to </h6>
                                    <h5>{formValues.address != '' ? formValues.address : addressData}</h5>
                                </div>
                                {
                                    (address_header == 0 && !step) ?
                                        <div className="address_btn_current_location mt-2" style={{ background: 'var(--primary_color', color: '#fff' }} onClick={() => {
                                            handleLocateme()
                                            setcurrent_Step(1)
                                            setIsFocused(true)
                                        }}>
                                            Use my Current location
                                        </div>
                                        :
                                        <div className="address_btn_current_location mt-2" style={{ background: 'var(--primary_color', color: '#fff' }} onClick={() => {
                                            setcurrent_Step(1)
                                            setIsFocused(true)
                                        }}>
                                            confirm my location
                                        </div>
                                }

                            </div>
                        }
                        {
                            current_Step == 1 &&
                            <div className='modal_address_footer' style={{ height: 'auto' }}>
                                <div className="address_btn" onClick={handleSubmit} style={{ background: isClickable && 'var(--primary_color', color: isClickable && '#fff' }}>
                                    {
                                        address_header == 0 ? 'Add Address' : 'Update Address'
                                    }
                                    {
                                        addressButtonLoader &&
                                        <ClipLoader className="ms-3" size={16} color={'#fff'} />
                                    }
                                </div>
                            </div>
                        }





                    </div>
                </LoadScript>

            </Modal>

        </>
    );
}

export default MobileAddressModal;